export const environment = {
  production: true,
  apiCosta: 'https://www.costaextra.it',
  cws: 'https://api.cws.otosrl.com/v2',
  nexi: 'https://ecommerce.nexi.it/ecomm/ecomm/DispatcherServlet',
  sso: 'https://www.costaextra.it/CostaClick/it-IT/LoggedOn/Pages/OtoLoginAreaMerchandising.aspx',
  ga: 'G-GP5JW1GJ22',
};
